import { required, email } from 'vuelidate/lib/validators';
export default {
  guests: {
    $each: {
      email: { required, email }
    }
  },
  demoNote: { required },
};
